import { useEffect, useRef, useState } from 'react';
import { MapboxOverlay } from '@deck.gl/mapbox';

import { useMaplibreMap } from '@App/components/MaplibreMap/maplibre-map.context';
import MapCard from '@App/components/MapCard/MapCard';
import MapContainer from '@App/components/MapContainer/MapContainer';

import InteractiveLegend from '../InteractiveLegend/InteractiveLegend';

import {
  createTileLayer,
  getLayerUrl,
  WATER_QUALITY_LAYER_ID,
} from './water-quality-layer.utils';

function WaterQualityLayer({ selectedLayer, selectedResourceId }) {
  const [hoveredPixelColor, setHoveredPixelColor] = useState(null);

  const { map, isLoading } = useMaplibreMap();
  const deckOverlayRef = useRef(null);

  useEffect(() => {
    if (isLoading || !map || deckOverlayRef.current) {
      return undefined;
    }

    const deckOverlay = new MapboxOverlay({
      interleaved: true,
      layers: [],
      getCursor: () => {},
    });

    map.addControl(deckOverlay);
    deckOverlayRef.current = deckOverlay;

    return () => {
      map.removeControl(deckOverlay);
      deckOverlayRef.current = null;
    };
  }, [isLoading, map]);

  useEffect(() => {
    if (isLoading || !map || !deckOverlayRef.current || !selectedResourceId) {
      return undefined;
    }

    let isCancelled = false;

    getLayerUrl(selectedLayer, selectedResourceId).then((tileUrl) => {
      if (isCancelled || !deckOverlayRef.current) {
        return;
      }

      deckOverlayRef.current.setProps({
        interleaved: true,
        layers: [
          createTileLayer(
            WATER_QUALITY_LAYER_ID,
            tileUrl,
            setHoveredPixelColor,
          ),
        ],
      });
    }).catch((err) => {
      console.error('Error building water quality layer url:', err);
    });

    return () => {
      isCancelled = true;
    };
  }, [selectedLayer, selectedResourceId, isLoading, map]);

  return (
    <MapContainer position="bottom-right">
      <MapCard className="pagasitikos-gulf-map__interactive-legend">
        <InteractiveLegend
          selectedLayer={selectedLayer}
          hoveredPixelColor={hoveredPixelColor}
        />
      </MapCard>
    </MapContainer>
  );
}

export default WaterQualityLayer;
